import { useEffect } from "react"

import {
  commonUserRetrieve,
  useCommonUserRetrieve,
} from "@boundless/bl-api-client/common/services"
import { useStore } from "zustand"

import { PendingComponent } from "@/components/error/PendingComponent"
import { store } from "@/lib/store"

export function ThemeWrapper({ children }: { children: React.ReactNode }) {
  const isAuthenticated = useStore(store, (state) => state.isAuthenticated)
  const primaryColor = useStore(store, (state) => state.primaryColor)
  const headerGradientColor = useStore(
    store,
    (state) => state.headerGradientColor,
  )
  const accentColor = useStore(store, (state) => state.accentColor)

  const { isLoading } = useCommonUserRetrieve({
    // When a partnerId is present, we are in an embedded/partner context where the
    // partner's theme (fetched above) takes precedence, so we intentionally skip
    // fetching user data/theme to avoid overriding the partner styling.
    query: {
      enabled: isAuthenticated,
      queryFn: ({ signal }) => {
        return commonUserRetrieve({ signal }).then((user) => {
          store.setState({
            partnerLogo: user.theme?.logo || null,
            primaryColor: user.theme?.primaryColor || null,
            headerGradientColor: user.theme?.headerGradientColor ?? null,
            accentColor: user.theme?.accentColor || null,
            perksEnabled: user.theme?.perksEnabled ?? true,
          })

          return user
        })
      },
    },
  })

  useEffect(() => {
    const gradientColor = headerGradientColor ?? primaryColor ?? ""
    document.documentElement.style.setProperty("--primary", primaryColor ?? "")
    document.documentElement.style.setProperty(
      "--header-gradient-color",
      gradientColor,
    )
    document.documentElement.style.setProperty(
      "--brand-accent",
      accentColor ?? "",
    )
  }, [primaryColor, headerGradientColor, accentColor])

  return <>{isLoading ? <PendingComponent /> : children}</>
}
